import React, { useState, useEffect } from "react";
import * as API from "../../api.js";
import {
  checkSubscriptionAndStorage,
  addUserAnalytic,
  updateOutTime,
  getPicstorkDefaultPlan,
} from "../../ReusableComponents/reusableFunctions";
import SideBarNew from "../../SideBarNew";
import { activesubscription } from "../../redux";
import { connect } from "react-redux";
import AppConstants from "../../AppConstants";
import { getActiveTeam } from "../../Teams";
import { ManageProjectAccess } from "../../Teams/ManageProjectAccess";
import TopBarNew from "../../TopBarNew.js";
import MenuIcon from "../../icons/MenuIcon.svg";
import TowerIcon2 from "../../icons/TowerIcon2.svg";
import TowerImages from "./TowerImages.js";
import { useLocation } from "react-router-dom";
import LoaderComponent from "../../ReusableComponents/LoaderComponent.js";
import ButtonWithIcon from "../../ReusableComponents/ButtonWithIcon.js";
import AeroCaptureMultiFileUploader from "./aeroCaptureMultiFileUploader.js";
import Noimageset from "../../assets/Images/Noimageset.png";

const UploadTowerImages = (props) => {
  const [user, setUser] = useState({});
  const [type, setType] = useState("");
  const [sidebarMode, setSidebarMode] = useState("shrunk");
  const [showBackIcon, setShowBackIcon] = useState(true);
  const [outId, setOutId] = useState("");
  const [towerImages, setTowerImages] = useState([]);
  const [showUploader, setShowUploader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [plans, setPlans] = useState([]);
  const [project, setProject] = useState(null);
  const [plan, setPlan] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  const [fetchImages, setFetchImages] = useState(false);
  const [tasks, setTasks] = useState([]);
  const location = useLocation();
  const { rowData, collectionData, breadcrumb } = location.state || {};
  const query = new URLSearchParams(useLocation().search);
  const id = query.get("id") || "";
  const [hasImages, setHasImages] = useState(
    collectionData?.images_count !== "0"
  );

  useEffect(() => {
    return () => {
      updateOutTime(outId);
    };
  }, [outId]);

  useEffect(() => {
    document.title = "PicStork - Upload Tower Images";

    getActiveTeam().then(() => {
      checkSubscriptionAndStorage(AppConstants.SERVICES.PICSTORK).then(
        (data) => {
          if (data.error || data.storageExceed || data.isExpired) {
            console.warn("Subscription issue:", data);
          }
        }
      );

      addUserAnalytic(props.location.pathname).then((id) => {
        setOutId(id);
      });

      if (props.location?.state?.user && props.location?.state?.type) {
        const { user, type, sidebarMode } = props.location.state;
        setUser(user);
        setSidebarMode(sidebarMode || "shrunk");
        setType(type);
      } else {
        API.getUserType().then(
          ([, type, user]) => {
            setUser(user);
            setType(type);
          },
          () => {
            window.location.replace("/login");
          }
        );
      }
    });
  }, []);

  const topbarConfigurations = {
    options: showBackIcon
      ? [
        { icon: MenuIcon, text: "Projects", path: "/picstork/towers" },

        ...(breadcrumb || []),
        { icon: MenuIcon, text: collectionData?.collection_name, path: "/picstork/upload-tower-images", rowData: rowData, collectionData: collectionData },
      ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
    breadcrumb: breadcrumb || []
  };

  useEffect(() => {
    const fetchProjectDetails = async () => {
      if (!rowData?.project_id) {
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const result = await API.getProjectDetailsById(rowData?.project_id);

        if (result.error) {
          setError(result.error);
        } else {
          setProject(result.project);

          // const defaultPlan = await getPicstorkDefaultPlan(result.project);
          // setPlan(defaultPlan);
        }
      } catch (err) {
        console.error("Error fetching project:", err);
        setError("Something went wrong while fetching project details.");
      } finally {
        setLoading(false);
      }
    };

    fetchProjectDetails();
  }, [rowData?.project_id]);

  const handleDetect = async () => {
    try {
      const planId = collectionData?.plan_id;
      const projectId = collectionData?.project_id;
      const projectName = (collectionData?.project_name || "").toString();
      const safeName =
        `${projectName}`.replace(/\s+/g, "").slice(0, 40) || "PicstorkTask";
      const randomTwoDigit = Math.floor(10 + Math.random() * 90);
      const autoName = `${safeName}Task${randomTwoDigit}`;

      const payload = {
        task_name: autoName,
        taskType: "detection",
        project_id: projectId,
        project_name: projectName,
        plan_id: planId,
        state: 2,
        status: AppConstants.TASK.STATUS.CREATING,
        type: [],
      };

      console.log("Creating detection task with payload:", payload);

      const created = await API.createTask(payload);
      localStorage.removeItem("created_task");
      localStorage.setItem("created_task", JSON.stringify(created.task));
      setIsDisable(true);

      if (collectionData && collectionData.id) {
        await API.updateTaskDetails(created.task.task_id, {
          state: 3,
          models: [
            {
              "id": "c6f19d35-ecb7-4f2d-91a4-47fa6c37eb33",
              "name": "detectron2_img_Vegetation_encroachment123",
              "usable": true,
              "objects": [
                "Vegetation_encroachment"
              ],
              "display_name": "Tower_Vegetation_encroachment",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T13:05:32.256Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "d05bcde0-a6b8-4a17-aa10-8abfc6e37059",
              "name": "detectron2_img_U_Bolt",
              "usable": true,
              "objects": [
                "U_Bolt"
              ],
              "display_name": "Tower_U_Bolt",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T13:01:54.294Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "aef551d2-7ac2-4941-8a4f-c48a0f208e17",
              "name": "detectron2_img_Suspension_Clamp123",
              "usable": true,
              "objects": [
                "Suspension_Clamp",
                " Suspension_Clamp_Defect"
              ],
              "display_name": "Tower_Suspension_Clamp",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:59:17.393Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "a7b4d03a-43e9-4953-b21f-c42e59c1c36e",
              "name": "detectron2_img_Insulator123",
              "usable": true,
              "objects": [
                "Insulator"
              ],
              "display_name": "Tower_Insulator",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:56:48.858Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "f94ffa6c-f26c-43b8-947b-d9dd94fc1458",
              "name": "detectron2_img_Damper123",
              "usable": true,
              "objects": [
                "Damper"
              ],
              "display_name": "Tower_Damper",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:54:30.112Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "b1f09288-1c63-4718-8114-15ea76356ec5",
              "name": "detectron2_img_Corona_Ring123",
              "usable": true,
              "objects": [
                "Corona_Ring"
              ],
              "display_name": "Tower_Corona_Ring",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:50:38.535Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "69308950-90fe-445b-853e-5942e3dce1cb",
              "name": "detectron2_img_Foundation123",
              "usable": true,
              "objects": [
                "Foundation ",
                "Foundation_Cracks"
              ],
              "display_name": "Tower_Foundation",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:07:24.983Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            }
          ],
          collection_id: collectionData?.id,
          task_purpose: "Defect",
          linked_map: created.task.linked_map || null,
          task_parameters: {
            output_type: "BOX",
            measurement_type: null,
            dsm_url: null,
            dtm_url: null,
          },
          fps: created.task.fps || null,
        });

        await API.updateTaskDetails(created.task.task_id, {
          state: 4,
        });

        await API.updateTask(
          created.task.task_id,
          AppConstants.TASK.STATUS.PENDING,
          AppConstants.SERVICES.PICSTORK
        );
      }
    } catch (err) {
      console.error("Create detection task failed", err);
    }
  };

  const fetchTasksForProject = async () => {
    if (!rowData?.project_id || !collectionData?.plan_id) return [];

    try {
      const response = await API.getAllTask(
        rowData?.project_id,
        collectionData?.plan_id,
        " ",
        0,
        100,
        "PicStork"
      );

      if (response && response.tasks) {
        const tasks = response.tasks;
        setTasks(tasks);

        const relatedTasks = tasks.filter(
          (task) => task.image_collection_id === collectionData.id
        );

        const hasFailedTask = relatedTasks.some(
          (task) => task.status === AppConstants.TASK.STATUS.FAILED
        );

        const isDisabled =
          (relatedTasks.length > 0 && !hasFailedTask)

        setIsDisable(isDisabled);

        return tasks;
      }

      return [];
    } catch (err) {
      console.error("Error fetching tasks:", err);
      return [];
    }
  };


  useEffect(() => {
    if (rowData?.project_id && collectionData?.plan_id) {
      fetchTasksForProject();
    }
  }, [rowData?.project_id, collectionData?.plan_id, isDisable]);

  const fetchTowerImages = async () => {
    if (!rowData?.project_id) {
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await API.getLatestImageSets(
        "project",
        100000,
        rowData.project_id,
        0,
        "PickStork"
      );
      if (response?.imageCollections) {
        setTowerImages(response?.imageCollections || []);
      }
    } catch (err) {
      console.error("Error fetching tower images:", err);
      setError("Failed to load images");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTowerImages();
  }, [rowData?.project_id]);

  const sidebarConfigurations = {
    options: showBackIcon
      ? [
        { icon: MenuIcon, text: "Home", path: "/picstork/dashboard" },
        { icon: TowerIcon2, text: "Projects", path: "/picstork/towers" },
      ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  useEffect(() => {
    const fetchPlans = async () => {
      if (!rowData?.project_id) return;

      try {
        const res = await API.getPlans(
          rowData.project_name || "", // projectName
          "", // searchString
          10000, // pageSize
          1, // pageNumber
          "", // tasktype
          rowData.project_id, // projectId
          "", // fromDate
          "", // toDate
          "", // orderBy (or any column supported)
          "" // orderType
        );
        setPlans(res?.plans || []); // depends on API response structure
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    };

    fetchPlans();
  }, [rowData?.project_id]);

  return user?.username ? (
    <div className="wrapper">
      <ManageProjectAccess
        projectId={false}
        closeManageAccess={() => { }}
        senderData={user}
        propsData={undefined}
      />

      <SideBarNew
        config={sidebarConfigurations}
        showMainDashboardIcons={showBackIcon}
        parentSidebarSwitch={() =>
          setSidebarMode(sidebarMode === "shrunk" ? "expanded" : "shrunk")
        }
      />

      <div
        className="right-content"
        style={{ backgroundColor: "#EAEDF0" }}
        onClick={() => setSidebarMode("shrunk")}
      >
        <TopBarNew config={topbarConfigurations} />

        <>
          {loading ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                width: "100vw",
                backgroundColor: "#f5f6f8",
              }}
            >
              <LoaderComponent message="Fetching tower images..." />
            </div>
          ) : (
            <>
              {/* Header Section */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "20px 30px",
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "550",
                    color: "#1F1C45",
                  }}
                >
                  {collectionData?.collection_name}
                </h2>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <ButtonWithIcon
                    text="Detect"
                    onClick={handleDetect}
                    isDisabled={
                      isDisable || !hasImages
                    }
                  />

                  <AeroCaptureMultiFileUploader
                    isDisabled={isDisable}
                    uploadBtnNotRequired={false}
                    dragDropUiRequired={false}
                    serviceName={AppConstants.SERVICES.PICSTORK}
                    acceptFileType={AppConstants.FILETYPES.PNGJPEGTIF}
                    collection={{ id: collectionData?.id || "" }}
                    planId={collectionData?.plan_id || ""}
                    oldFiles={[]}
                    user={user?.userid}
                    onImageUpload={async (uploadPercent) => {
                      if (uploadPercent === 100) {
                        await new Promise((resolve) =>
                          setTimeout(resolve, 2500)
                        );
                        await fetchTowerImages();
                        setFetchImages(true);
                        setHasImages(true);
                        setShowUploader(false);
                      }
                    }}
                    openImportPopup={(popupData) =>
                      console.log("Import popup:", popupData)
                    }
                    startGoogleDriveSelection={false}
                    clearGoogleDriveStates={() => { }}
                  />
                </div>
              </div>

              {/* Images or Empty State */}
              <div>
                {collectionData?.images_count !== "0" || fetchImages ? (
                  <TowerImages
                    images={collectionData}
                    userDetails={user}
                    projectId={collectionData?.project_id || ""}
                    planId={collectionData?.plan_id || ""}
                  />
                ) : (
                  <div
                    className="rmp-dashboard-empty-data-message"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "80vh",
                    }}
                  >
                    <img
                      style={{ height: "150px", width: "150px" }}
                      src={Noimageset}
                      alt="No images"
                    />
                    <p style={{ marginTop: "10px" }}>No images available</p>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      </div>
    </div>
  ) : (
    <div />
  );
};

const mapDispatchToProps = (dispatch) => ({
  activesubscription: (payload) => dispatch(activesubscription(payload)),
});

const mapStateToProps = (state) => ({
  SubscriptionData: state.subscription.subscriptionData,
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadTowerImages);
